import React, { useCallback } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import RefreshIcon from '@atlaskit/icon/core/refresh';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import {
	useIsRefreshing,
	useIssueSearchActions,
} from '../../../services/issue-search/selectors.tsx';
import messages from './messages.tsx';

const RefreshButton = () => {
	const isRefreshing = useIsRefreshing();

	const { refresh } = useIssueSearchActions();

	const handleClick = useCallback(
		(_: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'reloadIssueListButton');
			refresh();
		},
		[refresh],
	);
	const { formatMessage } = useIntl();

	return (
		<IconButton
			appearance="subtle"
			onClick={handleClick}
			testId="issue-navigator.common.ui.refresh-button.refresh-button"
			label={formatMessage(messages.tooltip)}
			icon={(iconProps) => (
				<RefreshIcon
					{...iconProps}
					color={token('color.icon.subtle')}
					LEGACY_primaryColor="color.icon.subtle"
				/>
			)}
			isLoading={isRefreshing}
		/>
	);
};

export default RefreshButton;
